/**
 * @generated SignedSource<<a0f9a59a7e0748a9aa21366ea87ddedc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SubscriptionUpdateSeatsCountMutation$variables = {
  count: number;
};
export type SubscriptionUpdateSeatsCountMutation$data = {
  readonly updateSeatsCount: {
    readonly account: {
      readonly id: number;
    } | null | undefined;
  };
};
export type SubscriptionUpdateSeatsCountMutation = {
  response: SubscriptionUpdateSeatsCountMutation$data;
  variables: SubscriptionUpdateSeatsCountMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "count"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "count",
        "variableName": "count"
      }
    ],
    "concreteType": "UpdateSeatsCountResult",
    "kind": "LinkedField",
    "name": "updateSeatsCount",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "accounts",
        "kind": "LinkedField",
        "name": "account",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SubscriptionUpdateSeatsCountMutation",
    "selections": (v1/*: any*/),
    "type": "mutation_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SubscriptionUpdateSeatsCountMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "caf2637e8ee61ecc695a95f93ad3329d",
    "id": null,
    "metadata": {},
    "name": "SubscriptionUpdateSeatsCountMutation",
    "operationKind": "mutation",
    "text": "mutation SubscriptionUpdateSeatsCountMutation(\n  $count: Int!\n) {\n  updateSeatsCount(count: $count) {\n    account {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "10a59f514f4b749d546958250aaab48f";

export default node;
